import { Box, Typography } from "@mui/material";

import { useState } from "react";
import useAPI from "../../../../../../api/hooks/useAPI";
import StyledDataGrid from "../../../../../../components/StyledDataGrid";
import { ComplexEntityTypes } from "../../../../../../utils/constants";
import { getPrettyDate } from "../../../../../../utils/timestamp";
import { useEntities } from "../../../hooks/useEntities";
import EntityDrawer from "../../EntityDrawer/EntityDrawer";

export default function AppTokensView({ entityData }) {
  const { trackEvent } = useAPI();
  const [entityForDrawer, setEntityForDrawer] = useState(false);
  const { useQueryForEntitiesByType } = useEntities();

  const { data: nhiEntities } = useQueryForEntitiesByType({
    type: ComplexEntityTypes.NONHUMAN_IDENTITY,
    enabled: Boolean(entityData?.salesforce_data?.oauth_tokens),
  });

  const relatedOAuthTokenIDs = entityData?.salesforce_data?.oauth_tokens?.map(
    (token) => token.token_id
  );

  const relatedOAuthTokenEntities =
    nhiEntities &&
    relatedOAuthTokenIDs &&
    nhiEntities.filter((entity) =>
      relatedOAuthTokenIDs.includes(entity.unique_id)
    );

  const tokenColumns = [
    {
      field: "user_name",
      headerName: "User",
      flex: 1,
      minWidth: 130,
      align: "left",
      headerAlign: "left",
      disableReorder: true,
    },
    {
      field: "created_date",
      headerName: "Created",
      width: 130,
      minWidth: 120,
      align: "left",
      headerAlign: "left",
      disableReorder: true,
      valueGetter: (params) => params.value.timestamp_utc,
      renderCell: (params) => (
        <Typography variant="caption">{getPrettyDate(params.value)}</Typography>
      ),
    },
    {
      field: "last_used_date",
      headerName: "Last Used",
      minWidth: 120,
      width: 130,
      align: "left",
      headerAlign: "left",
      disableReorder: true,
      valueGetter: (params) => params.value.timestamp_utc,
      renderCell: (params) => (
        <Typography variant="caption">{getPrettyDate(params.value)}</Typography>
      ),
    },
    {
      field: "use_count",
      headerName: "Use Count",
      minWidth: 130,
      align: "left",
      headerAlign: "left",
      disableReorder: true,
    },
  ];

  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
      {relatedOAuthTokenEntities && relatedOAuthTokenEntities.length > 0 && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <Typography variant="subtitle2">Related OAuth Tokens</Typography>
          </Box>
          <Box mt={1}>
            <StyledDataGrid
              rows={entityData?.salesforce_data?.oauth_tokens}
              columns={tokenColumns}
              getRowId={(row) => row.token_id}
              initialState={{
                sorting: {
                  sortModel: [{ field: "last_used_date", sort: "desc" }],
                },
              }}
              onRowClick={(params) => {
                trackEvent(
                  `User clicked on OAuth token of ${params.row.user_name}, from app details view ${entityData?.display_name}`
                );
                setEntityForDrawer(
                  relatedOAuthTokenEntities.find(
                    (entity) => entity.unique_id === params.row.token_id
                  )
                );
              }}
              sx={{
                "& .MuiDataGrid-row": {
                  cursor: "pointer",
                },
              }}
            />
          </Box>
        </Box>
      )}
      <EntityDrawer
        openDrawer={entityForDrawer}
        selectedEntity={entityForDrawer}
        onClose={() => {
          setEntityForDrawer(null);
        }}
      />
    </Box>
  );
}
